const STATS = [
  { value: '5000+', label: 'Casino Games' },
  { value: '80,000', label: 'Players' },
  { value: '50+', label: 'Game Providers' },
  { value: '99%', label: 'Uptime Guarantee' },
];

const VALUES = [
  { icon: 'ri-shield-star-line', title: 'Player Safety First', desc: 'Every decision we make starts with player protection. From 256 bit SSL encryption to certified RNG systems, your security is our foundation at Bybid9.' },
  { icon: 'ri-flashlight-line', title: 'Lightning Fast Payouts', desc: 'We believe winners should enjoy their money immediately. Our average withdrawal processing time is under 30 minutes for verified accounts. Min withdrawal AUD 30.' },
  { icon: 'ri-heart-3-line', title: 'Community Driven', desc: 'Bybid9 was built by players, for players. We listen to feedback, adapt quickly, and always put the player experience above everything else.' },
  { icon: 'ri-award-line', title: 'Fair Play Guaranteed', desc: 'All games are independently audited by BMM Testlabs and iTech Labs. Every spin, every deal, every roll is provably fair and transparent.' },
  { icon: 'ri-customer-service-2-line', title: '24/7 Live Support', desc: 'Our dedicated support team is available around the clock via live chat, Telegram, WhatsApp, and Facebook. Real humans, real help, real fast.' },
  { icon: 'ri-global-line', title: 'Australia Focused', desc: 'We understand Australian players. AUD currency, local payment methods like PayID and OSKO, and promotions tailored for the Aussie market.' },
];

export default function AboutSection() {
  return (
    <section className="relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #0d1117 0%, #0a1520 50%, #0d1117 100%)' }}>
      <div className="section-divider absolute top-0 left-0 w-full"></div>

      {/* Ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] pointer-events-none"
        style={{ background: 'radial-gradient(ellipse, rgba(71,202,241,0.05) 0%, transparent 70%)', filter: 'blur(60px)' }}
      ></div>

      {/* About intro */}
      <div className="relative py-16 sm:py-20 md:py-24 px-4 sm:px-5 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 sm:mb-14 md:mb-16">
            <div className="badge-blue mb-5">
              <i className="ri-information-line"></i> About Bybid9
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-white mb-4 sm:mb-5 leading-tight px-1">
              <span className="text-gradient-blue">Premier Exclusive</span>
              <br />
              Online Entertainment Platform in Asia
            </h2>
            <p className="text-[#56626B] text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
              Bybid9 is a legit Australian casino with fast payouts. Exclusive Monthly Deposit Ranking AUD 3,999, Daily Easy Step AUD 100, min deposit AUD 10.
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-16">
            {STATS.map((s) => (
              <div key={s.label} className="glass-card rounded-2xl p-6 md:p-8 text-center card-hover-glow">
                <div className="text-3xl md:text-4xl font-black mb-2 stat-number">{s.value}</div>
                <div className="text-[#56626B] text-xs md:text-sm font-medium">{s.label}</div>
              </div>
            ))}
          </div>

          {/* Body text */}
          <div className="max-w-4xl mx-auto space-y-5 text-[#56626B] text-sm md:text-base leading-relaxed text-center">
            <p>
              <strong className="text-white">Bybid9</strong> is not just another online casino. It is a complete gaming ecosystem designed from the ground up to deliver the ultimate player experience. Licensed by <strong className="text-[#47CAF1]">PAGCOR</strong>, we operate under the strictest regulatory standards to ensure every game is fair, every transaction is secure, and every player is treated with respect.
            </p>
            <p>
              Our platform hosts over <strong className="text-white">5,000 real money games</strong> from 50+ world-class providers including JILI, BNG, VPower, Mega888, Pegasus, Pragmatic Play, and more. From high RTP pokies and progressive jackpots to immersive live dealer tables and action-packed fishing games, there is something for every type of player.
            </p>
            <p>
              What truly sets us apart is our commitment to <strong className="text-white">player rewards</strong>. Our industry-leading welcome bonus is the <strong className="text-[#47CAF1]">100% Slot Welcome Bonus</strong> with min deposit AUD 10, plus ongoing promotions and a <strong className="text-[#47CAF1]">Referral Program</strong> that pays every 1 share AUD $3, 0.9% daily rebate, and 6% weekly commission.
            </p>
          </div>
        </div>
      </div>

      <div className="section-divider mx-4 md:mx-8"></div>

      {/* Values */}
      <div className="relative py-14 sm:py-16 md:py-20 px-4 sm:px-5 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <div className="badge-blue mb-5">
              <i className="ri-compass-3-line"></i> Our Principles
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-white mb-3">What We Stand For</h2>
            <p className="text-[#56626B] text-base max-w-xl mx-auto">
              Six core values drive every decision we make. These are not just words on a wall. They are the foundation of Bybid9.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {VALUES.map((v) => (
              <div key={v.title} className="group glass-card rounded-2xl p-6 flex flex-col items-center text-center gap-4 card-hover-glow cursor-default">
                <div
                  className="w-14 h-14 flex items-center justify-center rounded-2xl group-hover:scale-110 transition-transform duration-300"
                  style={{ background: 'rgba(71,202,241,0.1)', border: '1px solid rgba(71,202,241,0.25)' }}
                >
                  <i className={`${v.icon} text-[#47CAF1] text-2xl`}></i>
                </div>
                <h4 className="text-white font-bold text-sm">{v.title}</h4>
                <p className="text-[#56626B] text-xs leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
